export default {
  state: {
    defaultData: {},
  },

  getters: {
    getProvenanceData(state) {
      return state.defaultData;
    },
  },

  mutations: {
    setProvenanceData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
      };
    },
  },

  actions: {
    changeProvenanceData(context, infos) {
      context.commit("setProvenanceData", infos);
    },
  },
};
